export default __webpack_public_path__ + "static/media/oceania.fd488578.png";